/**
 * REST endpoints for the owner-side service-request flow.
 *
 *   POST /service-requests       — owner raises a complaint/service ticket
 *   GET  /service-requests       — owner lists their own tickets
 *   GET  /service-requests/:id   — owner reads one of their own tickets
 *
 * Admin-side counterparts live under /admin/service-requests in admin.ts.
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { ServiceRequestCategorySchema, ServiceRequestStateSchema, } from './admin.js';
/** Lean shape returned to the device owner — strips admin-only fields
 *  (raisedBy, raisedByUserId, resolution, resolutionReason, assignedAdminId,
 *  remark, createdAt, updatedAt) that the mobile app never displays. */
export const OwnerComplaintSchema = z.object({
    id: UuidSchema,
    complaintNumber: z.string(),
    deviceId: UuidSchema,
    serialNumber: z.string(),
    category: ServiceRequestCategorySchema,
    description: z.string(),
    state: ServiceRequestStateSchema,
    attachmentUrl: z.string().nullable(),
    attachmentMimeType: z.string().nullable(),
});
export const OwnerServiceRequestCreateBody = z.object({
    deviceId: UuidSchema,
    category: ServiceRequestCategorySchema,
    description: z.string().min(1).max(4000),
});
export const OwnerServiceRequestCreateResponse = z.object({
    id: UuidSchema,
    complaintNumber: z.string(),
    state: z.string(),
});
export const OwnerServiceRequestListResponse = z.object({
    requests: z.array(OwnerComplaintSchema),
});
export const OwnerServiceRequestDetailResponse = z.object({
    request: OwnerComplaintSchema,
});
export const ServiceRequestAttachmentBody = z.object({
    base64: z.string().min(1),
    /** HRD-18: video/* added — a picked complaint video used to have nowhere
     *  to go (only image/jpeg|png were ever accepted) and silently never left
     *  the phone. mp4/quicktime cover Android + iOS default recording formats. */
    mimeType: z.enum(['image/jpeg', 'image/png', 'video/mp4', 'video/quicktime']),
    filename: z.string().min(1).max(255),
});
//# sourceMappingURL=service.js.map